import _ from 'underscore';
import { ColumnsConfigBuilder } from '@bingads-webui-campaign/summary-grid-helper';

import { NegativeKeywordColumn } from './attributes/negative-keywords';
import { MatchTypeColumn } from './attributes/match-type';

export function getColumnsConfig({ options }) {
  const builder = new ColumnsConfigBuilder()
    .addCategory('Attribute', category => category.addColumns(_.compact([
      NegativeKeywordColumn,
      MatchTypeColumn,
    ])));
  return builder.getColumnsConfig(options);
}

export function getInlineEditableColumns({ i18n }) {
  return {
    NegativeKeyword: {
      editor: {
        type: 'text',
        getEditorValue: currentCellValue => currentCellValue.text,
      },
    },
    MatchType: {
      editor: {
        type: 'select',
        getEditorValue: currentCellValue => currentCellValue.type,
        options: [{
          value: 'Exact',
          text: i18n.getString('MatchTypeId_1'),
        }, {
          value: 'Phrase',
          text: i18n.getString('MatchTypeId_2'),
        }],
      },
    },
  };
}
